export const getAWSS3Url = async (fileName) => {
  try {
    const res = await fetch(
      `https://s5a26rvza4jr333q7wugsfkega0gurkl.lambda-url.eu-west-2.on.aws`,
      {
        headers: { "Content-Type": "application/json" },
        method: "POST",
        body: JSON.stringify({
          filename: fileName,
        }),
      }
    );
    const resultURL = await res.json();
    return resultURL;
  } catch (err) {
    console.log("Some Error occured while fetching the s3 URL's", err);
  }
};
